import getOptions from "../../../../../../../../../utils/generateOptions";

// eslint-disable-next-line no-shadow
export enum MapTabs {
	MAIN = "main",
	HISTORY = "history",
}

export const tabs = getOptions(Object.values(MapTabs));
